/* ========== ~~~~~~~~~~ TRIVIA AND POLLS ANALYTICS - TOTAL ANSWERS REPORT : STYLES ~~~~~~~~~~ ========== */
export default {
    totalanswersreport: {
    }
};